module.exports = __webpack_public_path__ + "static/media/pest.0e2047e3.png";